// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Iyyu","buttons":"PendingPaymentAlert_buttons__DJieG"};